const table = [
    {
        prop: 'Anio',
        label: 'Año',
        minWidth: 100
    },
    {
        prop: 'Mes',
        label: 'Mes',
        minWidth: 100
    },
    {
        prop: 'CoDmun',
        label: 'Cod. Municipio',
        minWidth: 150
    },
    {
        prop: 'Municipio',
        label: 'Municipio',
        minWidth: 150
    },
    {
        prop: 'Descripcion',
        label: 'Descripción',
        minWidth: 200
    },
    {
        prop: 'ofrecida_down',
        label: 'Velocidad Ofrecida Bajada',
        minWidth: 200
    },
    {
        prop: 'ofrecida_up',
        label: 'Velocidad Ofrecida Subida',
        minWidth: 200
    },
    {
        prop: 'maxima_down',
        label: 'Velocidad Máxima Bajada',
        minWidth: 200
    },
    {
        prop: 'maxima_up',
        label: 'Velocidad Máxima Subida',
        minWidth: 200
    },
    {
        prop: 'media_down',
        label: 'Velocidad Media Bajada',
        minWidth: 200
    },
    {
        prop: 'media_up',
        label: 'Velocidad Media Subida',
        minWidth: 200
    },
    {
        prop: 'minima_down',
        label: 'Velocidad Mínima Bajada',
        minWidth: 200
    },
    {
        prop: 'minima_up',
        label: 'Velocidad Mínima Subida',
        minWidth: 200
    },
    {
        prop: 'Desviacion_estandar_down',
        label: 'Desviación Estandar Bajada',
        minWidth: 250
    },
    {
        prop: 'Desviacion_estandar_up',
        label: 'Desviación Estandar Subida',
        minWidth: 250
    },
]

export default table
